export default {
  SHOW_OPT_OUT_MODAL: 'SHOW_OPT_OUT_MODAL',
  DISMISS_OPT_OUT_MODAL: 'DISMISS_OPT_OUT_MODAL',
  SET_OPT_OUT_REASON: 'SET_OPT_OUT_REASON'
};
